import React from "react";
import * as styles from "./CustomPromoBanner.module.scss";
import {
  BlockContentValue,
  Button,
  DiscountChip,
  UnstyledBlockContent
} from "@silversea-ssc/ui-components-react";
import { useRemotePromo } from "src/ssc-api/useRemotePromos";

type Props = {
  isVisible: boolean;
  onClick?: () => void;
  content: BlockContentValue | undefined;
  promoConfigurationCode: string | undefined;
};

const CustomPromoBanner: React.FC<Props> = ({
  isVisible,
  onClick,
  content,
  promoConfigurationCode
}) => {
  const promo = useRemotePromo(promoConfigurationCode);
  if (!isVisible) {
    return null;
  }

  return (
    <Button
      renderAs="div"
      dataContentPiece="customPromo_banner"
      className={styles.headerContainer}
      onClick={onClick}
      size="small"
    >
      <DiscountChip
        lineThrough={false}
        background="transparent"
        className={styles.discountChip}
      >
        <UnstyledBlockContent
          value={content}
          tokens={promo.data?.tokenValues}
        />
      </DiscountChip>
    </Button>
  );
};

export default CustomPromoBanner;
